import {
    Container,
    Row,
    Col,
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import Form from "@/components/Shared/Form";
import EditableImage from "@/components/EditableImage";
import EditableText from "@/components/EditableText";
import React, { useRef, useState, useEffect } from 'react';
import LightBlulbIcon from "/public/site-assets/svg/light-blub.svg"
import BrushIcon from "/public/site-assets/svg/brush.svg"
import LeafIcon from "/public/site-assets/svg/leaf.svg"
import ClipIcon from "/public/site-assets/svg/clip.svg"
import PencilIcon from "/public/site-assets/svg/pencil.svg"
import Button from "@/components/Button";

import { motion } from 'framer-motion';
import BlogCard from "@/components/Shared/BlogCard";
import Arrow from '@/public/site-assets/svg/swiper-arrow.svg';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';


export default function LatestBlogs({
    className,
    global,
    pathPrefix,
    post,
    heading,
    content,
    swiperID = 'latest-blogs-swiper',
    xl,
    lg,
    md,
    sm,
    pagePrefix = "/blog/",
    pagePrefixTag = "/",
    slug,
    post_category,
    heading_tag,
    cta_title,
    cta_link,

    disable_swiper,
    swiperLoop,
    alignHeading,
    load_more_cta_title,

    searchKeyword,
    notpostpage,

}) {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);


    const [displayCount, setDisplayCount] = useState(5);
    const handleViewMore = () => {
        setDisplayCount(prevCount => prevCount + 5);
    };


    const settings = {
        modules: [Navigation, Autoplay],
        loop: swiperLoop,
        spaceBetween: 50,
        centeredSlides: false,
        slidesPerView: 1,
        autoHeight: false,
        speed: 500,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: `.${swiperID}.swiper-next`,
            prevEl: `.${swiperID}.swiper-prev`
        },
        breakpoints: {
            320: {
                spaceBetween: 10,
                slidesPerView: sm,
            },
            768: {
                spaceBetween: 50,
                slidesPerView: md,
            },
            991: {
                spaceBetween: 50,
                slidesPerView: lg,
            },
            1399: {
                spaceBetween: 50,
                slidesPerView: xl,
            }
        }
    }

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Adjust threshold as needed, make it smaller for more sensitive detection
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(sectionRef.current);

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
            // setIsVisible(!mobileDevice); // Hide motion on mobile devices
        };

        handleResize(); // Call initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    // Filter by keyword
    const filteredPosts = post?.filter(item => item.title.toLowerCase().includes(searchKeyword?.toLowerCase()));

    return (
        <>
            <section ref={sectionRef} className={clsx(className, styles.root)}>
                <Container className='position-relative'>
                    <div className='floating-icon'><LightBlulbIcon /></div>
                    <div className='floating-icon'><LeafIcon /></div>
                    <div className='floating-icon'><PencilIcon /></div>
                    <div className='floating-icon'><ClipIcon /></div>
                    <div className='floating-icon'><BrushIcon /></div>
                    {disable_swiper != true ?
                        content && (
                            <EditableText
                                content={content}
                                path={`${pathPrefix}.content`}
                                global={global}
                                tag={`div`}
                                className={`d-none d-lg-block mb-3 subtitle`}
                            />
                        ) : ""}
                    <div className={`d-flex justify-content-between gap-4 align-items-${alignHeading} mb-4 wrapper`}>
                        {heading && (
                            <EditableText
                                content={heading}
                                path={`${pathPrefix}.heading`}
                                global={global}
                                tag={`${heading_tag}`}
                                className={`h3`}
                            />
                        )}

                        {disable_swiper ?
                            content && (
                                <EditableText
                                    content={content}
                                    path={`${pathPrefix}.content`}
                                    global={global}
                                    tag={`div`}
                                    className={`d-none d-lg-block mb-3 subtitle`}
                                />
                            )
                            :
                            <div className='d-flex align-items-center'>
                                <button
                                    className={`${swiperID} swiper-prev border-0 bg-transparent`}
                                    aria-label="Prev"
                                >
                                    <Arrow />
                                </button>
                                <button
                                    className={`${swiperID} swiper-next border-0 bg-transparent`}
                                    aria-label="Next"
                                >
                                    <Arrow />
                                </button>
                            </div>
                        }

                    </div>
                    {disable_swiper ?
                        <div>
                            <div className='not-swiper-container mb-5'>
                                {notpostpage ?
                                    post?.slice(0, displayCount).map((postItem, index) => (
                                        <motion.div initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.1 }}>
                                            <BlogCard
                                                post={postItem}
                                                // pathURL={pagePrefix}
                                                slug={slug}
                                                className={`overflow-hidden`}
                                            // post_category={post_category}
                                            />
                                        </motion.div>
                                    )) :
                                    filteredPosts?.slice(0, displayCount).map((postItem, index) => (
                                        <motion.div className={`${postItem.tag} ${postItem.blog_category}`} initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.1 }}>
                                            <BlogCard
                                                post={postItem}
                                                // pathURL={pagePrefix}
                                                slug={slug}
                                                className={`overflow-hidden`}
                                            // post_category={post_category}
                                            />
                                        </motion.div>
                                    ))}

                            </div>
                            {filteredPosts?.length > displayCount && (
                                <Container>
                                    <div className="text-center mb-5">
                                        <Button
                                            text={`${load_more_cta_title}`}
                                            className={`load-more-btn m-0 w-100 justify-content-center `}
                                            onClick={handleViewMore}
                                            showArrow={false}
                                        >
                                        </Button>
                                    </div>
                                </Container>
                            )}
                            {notpostpage ?
                                post?.length < 1 && (
                                    <div className='text-center mb-5'><p>Sorry, there's no available post at the moment.</p></div>
                                ) :
                                filteredPosts?.length < 1 && (
                                    <div className='text-center mb-5'><p>Sorry, there's no available post at the moment.</p></div>
                                )}
                        </div>
                        :
                        <div className='swiper-container'>
                            <Swiper {...settings}>
                                {post.slice(0, displayCount).map((postItem, index) => (
                                    <SwiperSlide key={index}>
                                        <motion.div initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.1 }}>
                                            <BlogCard
                                                post={postItem}
                                                // pathURL={pagePrefix}
                                                slug={slug}
                                            // post_category={post_category}
                                            />
                                        </motion.div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    }
                    {cta_title && (
                        <div className='text-center'>
                            <Button
                                text={`${cta_title}`}
                                url={`${cta_link}`}
                                className={`m-0 defaultBtn`}
                            />
                        </div>
                    )}
                </Container>
            </section>
        </>
    )
}

LatestBlogs.defaultProps = {
    pathPrefix: "",
    className: "py-5",
    heading: "Tincidunt pellentesque tortor",
    content: "FREQUENTLY ASKED QUESTIONS",
    xl: 4,
    lg: 4,
    md: 3,
    sm: 2,
    heading_tag: "h4",
    disable_swiper: false,
    swiperLoop: true,
    alignHeading: "start",
    load_more_cta_title: "Load more",
    notpostpage: false
};

LatestBlogs.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
    heading: PropTypes.string,
    content: PropTypes.string,
    xl: PropTypes.number,
    lg: PropTypes.number,
    md: PropTypes.number,
    sm: PropTypes.number,
    heading_tag: PropTypes.string,
    disable_swiper: PropTypes.bool,
    swiperLoop: PropTypes.bool,
    alignHeading: PropTypes.string,
    load_more_cta_title: PropTypes.string,
    notpostpage: PropTypes.bool
};